interface PanelProps {
  children: React.ReactNode;
  className?: string;
}

export function Panel({ children, className = '' }: PanelProps) {
  return (
    <div className={`dossier-panel ${className}`}>
      {children}
    </div>
  );
}
